import React from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";

import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import SvgIcon from "@mui/material/SvgIcon";
import InfoIcon from "@mui/icons-material/Info";
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import ClickAwayListener from "@mui/material/ClickAwayListener";

import BathroomFeatureGroupsIcons from "../../common/svgIcons/bathroomFeatureGroupIcons";
import {setLookContextMenu} from "../../../actions/lookFunctions";
import WithUpdateLookCartItem from "../hocs/withUpdateLookCartItem";


const LookContextMenuVanityContent = (props) => {

  const {vanitySubMenuOpened, contextButtonClick, anchorEl, buttons, setLookContextMenu} = props;

  const closePopper = () => {
    setLookContextMenu({
      opened: false,
      layerPosition: ""
    });
  }

  return (
    <Popper open={vanitySubMenuOpened}
            className="look-sidebar__modal look-sidebar__modal--secondary look-sidebar__modal--secondary-aligned"
            id={"sidebar-modal"}
            anchorEl={anchorEl.current}
            placement={"right-start"}
            transition
            disablePortal={false}>
      {({ TransitionProps }) => (
        <Grow
          {...TransitionProps}
          style={{ transformOrigin: "left top" }}
        >
          <div className="look-context__popper-content">
            <ClickAwayListener onClickAway={closePopper}>
              <Paper>
                <WithUpdateLookCartItem>
                  {(updateLookCartItem) => (
                    <MenuList id="context-menu">
                      {buttons.map(button => {
                        const currentPartId = button.partId;
                        return (
                          <MenuItem key={currentPartId} className="look-sidebar__modal-item" onClick={() => contextButtonClick(currentPartId, updateLookCartItem)}>
                            <ListItemIcon>
                              {BathroomFeatureGroupsIcons[currentPartId] ? <SvgIcon>{BathroomFeatureGroupsIcons[currentPartId]}</SvgIcon> : <InfoIcon/>}
                            </ListItemIcon>
                            <FormattedMessage id={"visualizer.bathroom.vanity." +currentPartId}/>
                          </MenuItem>
                        )
                      })}
                    </MenuList>
                  )}
                </WithUpdateLookCartItem>
              </Paper>
            </ClickAwayListener>
          </div>
        </Grow>
      )}
    </Popper>
  )
};

LookContextMenuVanityContent.propTypes = {
  contextButtonClick: PropTypes.func.isRequired,
  vanitySubMenuOpened: PropTypes.bool.isRequired,
  anchorEl: PropTypes.any.isRequired,
  buttons: PropTypes.array.isRequired,
}

const mapStateToProps = (store) => {
  const {contextMenu} = store.lookState;
  return {
    contextMenu
  };
};

const mapDispatchToProps = {
  setLookContextMenu
};

export default connect(mapStateToProps, mapDispatchToProps)(LookContextMenuVanityContent)
